import React, { useState } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
import { FaPlane, FaSave, FaTimes } from 'react-icons/fa';

export default function EmissaoAereoForm({ eventoId, onClose }) {
    const [formData, setFormData] = useState({
        data_hora_saida: '',
        data_hora_chegada: '',
        observacoes_gerais: ''
    });
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);

    const buscarDadosExistentes = React.useCallback(async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await api({
                method: 'get',
                action: `/eventoEmissaoAereo/${eventoId}`,
                token: token
            });

            if (response.data.status && response.data.data) {
                setFormData({
                    data_hora_saida: response.data.data.data_hora_saida || '',
                    data_hora_chegada: response.data.data.data_hora_chegada || '',
                    observacoes_gerais: response.data.data.observacoes_gerais || ''
                });
            }
        } catch (error) {
            console.log('Nenhum dado existente encontrado ou erro ao buscar:', error);
        } finally {
            setInitialLoading(false);
        }
    }, [eventoId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const token = localStorage.getItem('token');
        console.log('Token:', token);
        console.log('Evento ID:', eventoId);
        console.log('Form Data:', formData);

        try {
            const response = await api({
                method: 'post',
                action: '/eventoEmissaoAereo',
                token: token,
                data: {
                    evento_id: eventoId,
                    ...formData
                }
            });

            console.log('Response:', response);
            if (response.data.status) {
                toast.success('Solicitação enviada com sucesso!');
                onClose();
            } else {
                toast.error(response.data.msg || 'Erro ao enviar solicitação');
            }
        } catch (error) {
            console.error('Error:', error);
            console.error('Error response:', error.response);
            toast.error('Erro ao enviar solicitação: ' + (error.response?.data?.mensagem || error.message));
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Buscar dados existentes quando o componente carregar
    React.useEffect(() => {
        buscarDadosExistentes();
    }, [buscarDadosExistentes]);

    if (initialLoading) {
        return (
            <div className="text-center p-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
                <p className="mt-2">Carregando dados...</p>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-sm-6">
                    <div className="form-group">
                        <label htmlFor="data_hora_saida" className="form-label">
                            <FaPlane className="me-2" />
                            Data e Hora de Saída
                        </label>
                        <input
                            type="datetime-local"
                            className="form-control"
                            id="data_hora_saida"
                            name="data_hora_saida"
                            value={formData.data_hora_saida}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="form-group">
                        <label htmlFor="data_hora_chegada" className="form-label">
                            <FaPlane className="me-2" />
                            Data e Hora de Chegada
                        </label>
                        <input
                            type="datetime-local"
                            className="form-control"
                            id="data_hora_chegada"
                            name="data_hora_chegada"
                            value={formData.data_hora_chegada}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>
            </div>

            <div className="row mt-3">
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="observacoes_gerais" className="form-label">
                            Observações Gerais
                        </label>
                        <textarea
                            className="form-control"
                            id="observacoes_gerais"
                            name="observacoes_gerais"
                            value={formData.observacoes_gerais}
                            onChange={handleChange}
                            rows="4"
                            placeholder="Informe observações gerais sobre a solicitação de emissão de aéreo..."
                        />
                    </div>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-sm-12">
                    <div className="d-flex justify-content-end gap-2">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={loading}
                        >
                            <FaTimes className="me-2" />
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            <FaSave className="me-2" />
                            {loading ? 'Enviando...' : 'Enviar por Email'}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
}

